{% block uc_free_products_page %}
<sw-page class="uc-free-products-page">

    {% block uc_free_products_smart_bar_header %}
    <template #smart-bar-header>
        <sw-button
            class="uc-free-products-page__back-btn"
            variant="ghost"
            size="small"
            @click="goToConfig"
        >
            <sw-icon name="regular-chevron-left-s" size="16px" class="uc-free-products-page__back-icon" />
            {{ $tc('sellops-ultimate-cart.general.back') }}
        </sw-button>
        <h2>{{ $tc('sellops-ultimate-cart.freeProducts.pageTitle') }}</h2>
    </template>
    {% endblock %}

    {% block uc_free_products_content %}
    <template #content>
        <sw-card-view>

            <sw-card :title="$tc('sellops-ultimate-cart.freeProducts.cardTitle')">
                <p class="uc-free-products-page__subline">
                    {{ $tc('sellops-ultimate-cart.freeProducts.cardSubline') }}
                </p>
                <uc-free-product-manager />
            </sw-card>

        </sw-card-view>
    </template>
    {% endblock %}

</sw-page>
{% endblock %}
